<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon>Check In / Out</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes de Ventas</span>
      <span> /</span>
      <span>Check In - Out </span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row">
        <div class="col-8">
          <div class="row filtros-body">
            <div class="col d-flex align-items-center" style="max-width: 300px">
              <!-- Material checked -->
              <div class="form-check">
                <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
                  [value]="RB_TIPO_VISTA_RESUMEN" />
                <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
              </div>
              <!-- Material unchecked -->
              <div class="form-check">
                <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
                  [value]="RB_TIPO_VISTA_DETALLE" />
                <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
              </div>
            </div>
            <div class="col" style="max-width: 17%">
              <div class="md-form mb-0" (click)="focusInput('fechaDesde')">
                <label for="datetime">Desde:</label>
                <!-- <input type="datetime-local" id="fechaDesde" formControlName="fechaDesde" [value]="fechaDesdeValue"> -->
                <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" formControlName="fechaDesde"
                  required></mdb-date-picker>
                <div
                  *ngIf="formHeader.get('fechaDesde').invalid && (formHeader.get('fechaDesde').dirty || formHeader.get('fechaDesde').touched)">
                  <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde </mdb-error>
                  <mdb-error
                    *ngIf="formHeader.get('fechaHasta').errors?.invalidRange || formHeader.get('fechaDesde').errors?.invalidRange">El
                    rango no puede ser mayor a 31 días.</mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 17%">
              <div class="md-form mb-0" (click)="focusInput('fechaHasta')">
                <label for="datetime">Hasta:</label>
                <!-- <input type="datetime-local" id="fechaHasta" formControlName="fechaHasta" [value]="fechaHastaValue"> -->
                <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" formControlName="fechaHasta"
                  required></mdb-date-picker>
                <div
                  *ngIf="formHeader.get('fechaHasta').invalid && (formHeader.get('fechaHasta').dirty || formHeader.get('fechaHasta').touched)">
                  <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta </mdb-error>
                  <mdb-error
                    *ngIf="formHeader.get('fechaHasta').errors?.invalidRange || formHeader.get('fechaDesde').errors?.invalidRange">El
                    rango no puede ser mayor a 31 días.</mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 30%">
              <div class="md-form">
                <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Todos" formControlName="vendedores"></mdb-select>
                <label>Vendedor</label>
              </div>
            </div>
            <!-- <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <mdb-checkbox formControlName="producto_sin_sku">Incluir sin SKU</mdb-checkbox>
              </div>
            </div> -->
          </div>
          <!-- <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE" class="row filtros-body">
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Todos" formControlName="rubros"></mdb-select>
                <label>Rubro de Productos</label>
              </div>
            </div>

            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Todos" formControlName="familias"></mdb-select>
                <label>Familia de Productos</label>
              </div>
            </div>
          </div> -->
        </div>
        <div class="col-4">
          <dl class="row" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
            <dt class="col-1">
              <mdb-icon class="text-center green-text" fas icon="circle">
              </mdb-icon>
            </dt>
            <dd class="col-5">Dentro de rango</dd>
            <dt class="col-1">
              <mdb-icon class="text-center red-text" fas icon="circle">
              </mdb-icon>
            </dt>
            <dd class="col-5">Fuera de rango</dd>
          </dl>
          <dl class="row" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
            <dt class="col-1">
              <mdb-icon class="text-center yellow-text" fas icon="circle">
              </mdb-icon>
            </dt>
            <dd class="col-5">Local cerrado</dd>
            <dt class="col-1">
              <mdb-icon class="text-center blue-text" fas icon="circle">
              </mdb-icon>
            </dt>
            <dd class="col-5">Con stock</dd>
          </dl>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)"><mdb-icon fas
            icon="search"></mdb-icon>Buscar</button>
      </div>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_loading"
      class="w-100 d-block text-center">
      <mdb-spinner spinnerColor="blue"></mdb-spinner>
    </div>

    <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_loading"
      class="w-100 d-block text-center">
      <mdb-spinner spinnerColor="blue"></mdb-spinner>
    </div>


    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <table class="table table-striped table-hover table-sm align-middle w-100" *ngIf="resumen_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Vendedor</th>
            <th scope="col" class="text-center">Cant. Pedidos</th>
            <th scope="col" class="text-center">Tiempo Máx.</th>
            <th scope="col" class="text-center">Tiempo Mín.</th>
            <th scope="col" class="doble-linea text-center">Tiempo Prom.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center"
              *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">No se encontró información</td>
          </tr>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>{{ mov.nombre | uppercase }}</td>
            <td class="text-center">{{ mov.cantidad_elementos | numerico }}</td>
            <td class="text-center">{{ mov.tiempo_max | numerico }}</td>
            <td class="text-center">{{ mov.tiempo_min | numerico }}</td>
            <td class="text-center">{{ mov.tiempo_prom | numerico }}</td>
          </tr>
        </tbody>

        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table
        *ngIf="detalle_listaMovimientos"
        class="table table-striped table-hover table-sm w-100 table-checkin-detalle"
        [ngClass]="mostrarColumnaVendedorEnDetalle() ? 'table-checkin-detalle--con-vendedor' : 'table-checkin-detalle--sin-vendedor'">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col" class="col-pedido-checkin">N° Pedido</th>
            <th scope="col" class="col-factura-checkin">Factura</th>
            <th scope="col" class="col-rut-checkin">Rut</th>
            <th scope="col" class="col-cliente-checkin">Cliente</th>
            <th scope="col" class="col-direccion-checkin">Direccion</th>
            <th scope="col" class="col-comuna-checkin">Comuna</th>
            <th *ngIf="mostrarColumnaVendedorEnDetalle()" scope="col" class="col-vendedor-checkin">Vendedor</th>
            <th scope="col" class="text-center col-checkin-rango ch-head-corta">Check In</th>
            <th scope="col" class="col-fecha-checkin">Fecha</th>
            <th scope="col" class="text-center col-hora-in-checkin ch-head-corta">Check In</th>
            <th scope="col" class="text-center col-hora-out-checkin">Check Out</th>
            <th scope="col" class="text-center col-tiempo-checkin">Tiempo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center"
              *ngIf="!detalle_loading && detalle_listaMovimientos?.length === 0">No se encontró información</td>
          </tr>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td class="col-pedido-checkin">
              <!-- Mostrar número de pedido si el motivo es null -->
              <span *ngIf="!mov.motivo">
                {{ mov.numero_pedido }}
              </span>
              <!-- Mostrar el círculo con el color dependiendo del motivo -->
              <span *ngIf="mov.motivo">
                <mdb-icon [ngClass]="{'yellow-text': mov.motivo == 1, 'blue-text': mov.motivo == 2}" fas icon="circle">
                </mdb-icon>
              </span>
            </td>
            <td class="col-factura-checkin tm-hover-cell" [ngClass]="{'has-text': mov.numeros_factura}">
              <span *ngIf="mov.numeros_factura" class="tm-hover-text" [tmMarkIfTruncated]="mov.numeros_factura">{{ mov.numeros_factura }}</span>
            </td>
            <td class="col-rut-checkin ch-celda-sin-ellipsis">{{ mov.rutFormato | rut }}</td>
            <td class="col-cliente-checkin tm-hover-cell" [ngClass]="{'has-text': mov.cliente_proveedor_nombre}">
              <span *ngIf="mov.cliente_proveedor_nombre" class="tm-hover-text" [tmMarkIfTruncated]="mov.cliente_proveedor_nombre | uppercase">
                {{ mov.cliente_proveedor_nombre | uppercase }}
              </span>
            </td>
            <td class="col-direccion-checkin tm-hover-cell" [ngClass]="{'has-text': mov.direccion_nombre}">
              <span *ngIf="mov.direccion_nombre" class="tm-hover-text" [tmMarkIfTruncated]="mov.direccion_nombre | uppercase">
                {{ mov.direccion_nombre | uppercase }}
              </span>
            </td>
            <td class="col-comuna-checkin tm-hover-cell" [ngClass]="{'has-text': mov.nombrecomuna}">
              <span *ngIf="mov.nombrecomuna" class="tm-hover-text" [tmMarkIfTruncated]="mov.nombrecomuna | uppercase">
                {{ mov.nombrecomuna | uppercase }}
              </span>
            </td>
            <td *ngIf="mostrarColumnaVendedorEnDetalle()" class="col-vendedor-checkin tm-hover-cell" [ngClass]="{'has-text': mov.nombre}">
              <span *ngIf="mov.nombre" class="tm-hover-text" [tmMarkIfTruncated]="mov.nombre | uppercase">
                {{ mov.nombre | uppercase }}
              </span>
            </td>
            <td class="text-center col-checkin-rango">
              <mdb-icon [ngClass]="{'green-text': mov.rango, 'red-text': !mov.rango}" fas icon="circle">
              </mdb-icon>
            </td>
            <td class="col-fecha-checkin ch-celda-sin-ellipsis">{{ mov.fecha | date }}</td>
            <td class="text-center col-hora-in-checkin">{{ mov.hora_registro }}</td>
            <td class="text-center col-hora-out-checkin">{{ mov.hora_termino }}</td>
            <td class="text-center col-tiempo-checkin">{{ mov.tiempo | numerico }}</td>
          </tr>
          <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
            *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn size="sm" type="button" color="success" mdbWavesEffect class="btn btn-sm" *ngIf="!loadingExcel"
      (click)="resumenDownloadExcelPdf('XLS')">
      Excel
    </button>
    <button mdbBtn size="sm" type="button" color="success" class="btn btn-sm" disabled *ngIf="loadingExcel">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="sr-only">Loading...</span>
    </button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" *ngIf="!loadingExcel"
      (click)="detalleDownloadExcelPdf('XLS')">
      Excel
    </button>
    <button mdbBtn size="sm" type="button" color="success" class="btn btn-sm" disabled *ngIf="loadingExcel">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="sr-only">Loading...</span>
    </button>
  </div>
</div>
